const { MESSAGES_SORT_TYPE } = require('utils/constants');
const { sortByLatestMessage } = require('utils/chatSorting');

exports.groupChatLink = (group) => group.isAnnouncement ? `/app/classes/announcement/chat/${group.id}` : `/app/classes/chat/${group.sid}`;

exports.groupDetailsLink = (group) => `/app/classes/${group.id}`;

exports.canViewGroup = ({ group, rolePermissions, userIsInGroup }) => {

    return !!group
        && (!!userIsInGroup || !!rolePermissions?.canSeeChatMessagesNoJoin);
};

exports.filterGroupsVisibleToUser = (
    groups = [],
    currentUserGroups = [],
    rolePermissions = {}
) => {

    const visibleGroupCandidates = Array.isArray(groups) ? groups : [];
    const memberships = Array.isArray(currentUserGroups) ? currentUserGroups : [];
    const currentGroupIds = new Set(memberships.map(({ id }) => String(id)));

    return visibleGroupCandidates.filter((group) => !group?.private
        || rolePermissions?.canSeeChatMessagesNoJoin
        || currentGroupIds.has(String(group.id)));
};

exports.getGroupLastMessage = (group = {}, lastMessages = {}) => {

    const keys = [
        group?.sid,
        group?.channel?.sid,
        group?.conversation?.sid,
        group?.conversationId,
        group?.id
    ].filter((key) => key !== null && typeof key !== 'undefined');

    const matchingKey = keys.find((key) => lastMessages[key]);

    if (matchingKey) {
        return lastMessages[matchingKey];
    }

    return group?.channel?.lastMessage
        || group?.conversation?.lastMessage
        || null;
};

exports.getGroupLastActivity = (group, lastMessages) => {

    return exports.getGroupLastMessage(group, lastMessages)?.timestamp || null;
};

exports.gotoGroupLink = (group, currentUserGroups) => {

    const alreadyBelongs = currentUserGroups.find(({ id }) => id === group.id);

    if (alreadyBelongs) {
        return exports.groupChatLink(group);
    }

    return exports.groupDetailsLink(group);
};

exports.hasKnownGroupMessageAuthor = (lastMessage, { usersNameMap, currentUserId } = {}) => {

    if (!lastMessage) {
        return false;
    }

    if (!usersNameMap && typeof currentUserId === 'undefined') {
        return true;
    }

    if (lastMessage.author === currentUserId) {
        return true;
    }

    return !!usersNameMap?.[lastMessage.author];
};

exports.sortGroupsByName = (group1, group2) => group1.name.localeCompare(group2.name);

exports.sortGroups = ({ groups, sortFilter, lastMessages, usersNameMap, currentUserId }) => {

    groups = groups || [];

    // When it's sort by name they don't want any other sort to be included
    if (sortFilter === MESSAGES_SORT_TYPE.BY_NAME) {
        return groups.sort(exports.sortGroupsByName);
    }

    return sortByLatestMessage({
        items: groups,
        getLastMessage: (group) => exports.getGroupLastMessage(group, lastMessages),
        sortByName: exports.sortGroupsByName,
        isSortableLastMessage: (lastMessage) => exports.hasKnownGroupMessageAuthor(lastMessage, {
            usersNameMap,
            currentUserId
        })
    });
};
